// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../../utils/Utils.bs.js");
let DateFns = require("../DateFns/DateFns.bs.js");
let DateFns$1 = require("date-fns");
let Stdlib_Int = require("@rescript/runtime/lib/js/Stdlib_Int.js");
let Stdlib_JSON = require("@rescript/runtime/lib/js/Stdlib_JSON.js");
let DateFnsTz = require("date-fns-tz");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Stdlib_Result = require("@rescript/runtime/lib/js/Stdlib_Result.js");

function fromString(str) {
  let rfc3339Regex = /^(\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01]))$/;
  if (rfc3339Regex.test(str)) {
    return {
      TAG: "Ok",
      _0: str
    };
  } else {
    return {
      TAG: "Error",
      _0: str + " is not a valid date."
    };
  }
}

function toString(str) {
  return str;
}

function toLocalDate(t) {
  return DateFns$1.parseISO(t);
}

function fromLocalDate(date) {
  return DateFns.formatISO(date, "date", undefined);
}

function today(tz) {
  return DateFns.formatISO(DateFnsTz.utcToZonedTime(new Date(), tz), "date", undefined);
}

function getDate(t) {
  return Stdlib_Option.getOrThrow(Stdlib_Int.fromString(t.slice(8, 10), undefined), undefined);
}

function getMonth(t) {
  return Stdlib_Option.getOrThrow(Stdlib_Int.fromString(t.slice(5, 7), undefined), undefined);
}

function getYear(t) {
  return Stdlib_Option.getOrThrow(Stdlib_Int.fromString(t.slice(0, 4), undefined), undefined);
}

function encode(prim) {
  return prim;
}

function decode(json) {
  return Stdlib_Result.flatMap(Utils.Result.ofOption(`Could not decode ` + JSON.stringify(json) + ` as a string`, Stdlib_JSON.Decode.string(json)), fromString);
}

function format(date) {
  return DateFns$1.format(DateFns$1.parseISO(date), "MMMM dd");
}

exports.fromString = fromString;
exports.toString = toString;
exports.toLocalDate = toLocalDate;
exports.fromLocalDate = fromLocalDate;
exports.today = today;
exports.getDate = getDate;
exports.getMonth = getMonth;
exports.getYear = getYear;
exports.encode = encode;
exports.decode = decode;
exports.format = format;
/* Utils Not a pure module */
